import { observer } from "mobx-react-lite";
import { Button, Modal } from "@heroui/react";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";

const SuccessIcon = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="48" cy="48" r="48" fill="#dcfce7" />
    <circle cx="48" cy="48" r="32" fill="#bbf7d0" />
    <path
      d="M31 48L43 60L65 36"
      stroke="#16a34a"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LegalSuccessModal: React.FC = observer(() => {
  const { legal } = contractorDetailStore;

  return (
    <Modal.Backdrop
      isOpen={legal.submit.showSuccessModal}
      onOpenChange={(v) => {
        if (!v) legal.submit.closeSuccessModal();
      }}
    >
      <Modal.Container>
        <Modal.Dialog className="scd-success-modal">
          <Modal.CloseTrigger />
          <Modal.Body className="scd-success-modal__body">
            <div className="scd-success-modal__icon">
              <SuccessIcon />
            </div>
            <h3 className="scd-success-modal__title">
              Данные успешно сохранены
            </h3>
            <p className="scd-success-modal__desc">
              Юридические данные зарегистрированы в Т-Банке. Теперь вы можете
              полноценно пользоваться системой: принимать выплаты и
              просматривать юридическую информацию.
            </p>
            <Button
              variant="primary"
              onPress={() => legal.submit.closeSuccessModal()}
              className="scd-success-modal__btn"
            >
              Отлично!
            </Button>
          </Modal.Body>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
});

LegalSuccessModal.displayName = "LegalSuccessModal";
export default LegalSuccessModal;
